import { React, forwardRef, useState, useRef, useEffect } from 'react';
import { VscEyeClosed, VscEye } from "react-icons/vsc";

export const Input = forwardRef(function MyInput({ id, labelText, disabled, type, ...rest}, ref) {
    const [showPassword, setShowPassword] = useState(false);
    const [eyeDimensions, setEyeDimensions] = useState({ height: 0, marginBottom: 0 });
    const inputRef = useRef(null);
    
    const isPassword = type === 'password';
    
    useEffect(() => {
        if (inputRef.current) {
            const inputHeight = inputRef.current.offsetHeight;
            setEyeDimensions({
                height: inputHeight / 2,
                marginBottom: inputHeight / 4
            });
        }
    }, []);
    
    return (
        <div className="input">
            <label className="input" htmlFor={id}>{labelText}</label>
            <div className="input-container">
                <input 
                    className={`input ${disabled ? "disabled" : ""} ${isPassword ? 'pr-10' : ''}`}
                    ref={(element) => {
                        inputRef.current = element;
                        if (typeof ref === 'function') {
                            ref(element);
                        } else if (ref) {
                            ref.current = element;
                        }
                    }}
                    id={id}
                    disabled={disabled}
                    type={isPassword ? (showPassword ? 'text' : 'password') : type}
                    {...rest}
                />
                {isPassword && (
                    <div 
                        className="input-password-eye"
                        style={{ 
                            height: `${eyeDimensions.height}px`,
                            width: `${eyeDimensions.height}px`,
                            marginBottom: `${eyeDimensions.marginBottom}px`
                        }}
                    >
                        {showPassword ? 
                            <VscEyeClosed onMouseUp={() => setShowPassword(false)} /> : 
                            <VscEye onMouseUp={() => setShowPassword(true)} />
                        }
                    </div>
                )}
            </div>
        </div>
    );
});
